module.exports = __webpack_public_path__ + "static/media/bestfriends.5467fe3d.jpg";